import SeesawImage from "@/components/subject/Seesaw/SeesawImage";
import AnswerButtonGroup from "@/components/train/AnswerButtonGroup";
export default {
  name: "SeesawRender",
  components: {
    SeesawImage,
    AnswerButtonGroup
  },
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  methods: {
    onChoosed(l) {
      this.$emit('answer', l && l.length > 0 ? l[0] : null);
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};